import { createApiRequest } from "@/lib/api/createApiService";
import { TARGET_SETUP_OVERVIEW_ENDPOINTS } from "./target-setup-overview.endpoints";

export const targetSetupOverviewService = {
  getList: (params = {}, options = {}) =>
    createApiRequest({
      url: TARGET_SETUP_OVERVIEW_ENDPOINTS.LIST,
      method: "POST",
      body: params,
      ...options,
    }),
  getOrgBreakdown: (params = {}, options = {}) =>
    createApiRequest({
      url: TARGET_SETUP_OVERVIEW_ENDPOINTS.ORG_BREAKDOWN,
      method: "POST",
      body: params,
      ...options,
    }),
};
